import { devSettingsSchema } from '../devSettings.schema';
import { DEV_SETTINGS_STORAGE_KEY } from '../devSettings.types';
import type { DevSettings } from '../devSettings.types';

export const setStoredDevSettings = ({
  settings,
}: {
  settings: DevSettings;
}): void => {
  const validated = devSettingsSchema.parse(settings);

  window.localStorage.setItem(
    DEV_SETTINGS_STORAGE_KEY,
    JSON.stringify(validated)
  );
};
